import { render, staticRenderFns } from "./EvrakTanimla.vue?vue&type=template&id=39f2d01c&"
import script from "./EvrakTanimla.vue?vue&type=script&lang=js&"
export * from "./EvrakTanimla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports